import React, { useState } from "react";
import "./LCPArchives.css";
import { useStyles } from "../../hooks/useStyles";
import {
  createRequestWithAuthHeaders,
  getFullUrl,
} from "../../configs/axios-export.custom";
import UserContext, {
  doesUserHaveRole,
  ServerOrgRoles,
} from "../../services/UserContext";
import GrowlContext from "../../services/growlContext";
import { DateFormat, formatDate } from "../../utils/conversion/date-converters";
import { getData } from "./getresources";
import axios, { AxiosRequestConfig } from "axios";

interface LCPArchivesPlans {
  date: string;
  link: string;
  id: number;
}

interface LCPArchiveRecords {
  country: string;
  plans: LCPArchivesPlans[];
}

const LCPArchives: React.FC = (): JSX.Element => {
  const user = React.useContext(UserContext);
  const growl = React.useContext(GrowlContext);

  const styles = useStyles();
  const [archives, setArchives] = useState<Array<LCPArchiveRecords>>([]);
  const [searchValue, setSearchValue] = useState("");

  React.useEffect(() => {
    getData(growl.current, user, "lcp").then((r) => {
      if (!r) return;

      const data = Object.keys(r)
        .sort((a, b) => (a > b ? 1 : -1))
        .map((k) => {
          const collection = r[k];
          const record: LCPArchiveRecords = {
            country: k,
            plans: collection
              .sort((a, b) => {
                if (!a && !b) return 0;
                else if (a && !b) return -1;
                else if (!a && b) return 1;
                else return a > b ? 1 : -1;
              })
              .map((x) => ({
                id: x.id,
                date: formatDate(x.date, DateFormat.dd_MMMM_yyyy) || "",
                link: x.link,
              })),
          };
          return record;
        });
      setArchives(data);
    });
  }, []);

  const removePlan = async (
    archive: LCPArchiveRecords,
    item: LCPArchivesPlans
  ) => {
    let request: AxiosRequestConfig = {
      ...createRequestWithAuthHeaders(user),
      data: { id: item.id },
    };

    await axios
      .delete(
        getFullUrl("/api/admin/resource", { useDedicatedEnvironment: true }),
        request
      )
      .then((r) => {
        const newArchives = [...archives];
        const match = newArchives.find((x) => x.country === archive.country);
        if (!match) return;
        match.plans = [...match.plans.filter((r) => r.id !== item.id)];
        setArchives(newArchives);
      });
  };

  const isAdmin =
    doesUserHaveRole(user, ServerOrgRoles.admin) ||
    doesUserHaveRole(user, ServerOrgRoles.partialAdmin);

  return (
    <div className="resources-screen">
      <section className="header">
        <div className="header-title">
          <img
            src={styles.aidkonektIcon}
            style={styles.icon}
            alt="Aidkonekt"
            className="formIcon"
          />
          <span>LCP Archives</span>
        </div>
        <span className="header-subtitle">
          USG Local Compensation Plan Archive
        </span>
        <span className="header-description">
          Local Compensation Plans are essential to US Government Contracting
          budgets and proposals but can be difficult to come by. We have
          complied a database of LCP's we have on hand and will continue to
          build our database.
        </span>
      </section>

      <section className="lcp-list-section">
        <div className="lcp-search-block">
          <input
            type="text"
            placeholder="Country"
            onChange={(e) => setSearchValue(e.currentTarget.value)}
          />
          <button type="button" className="card-btn aid-blu-btn">
            Search
          </button>
        </div>
        <div className="country-list">
          {archives.map(
            (item, index) =>
              item.country.toLowerCase().indexOf(searchValue.toLowerCase()) !==
                -1 && (
                <React.Fragment key={item.country}>
                  <h3 className="list-title">{item.country}</h3>
                  <div className="list-content">
                    <ul>
                      {item.plans
                        .sort((a, b) => {
                          const aDate = new Date(a.date);
                          const bDate = new Date(b.date);
                          return aDate > bDate ? 1 : -1;
                        })
                        .map((plan, index) =>
                          isAdmin ? (
                            <li
                              key={plan.id}
                              className="list-item"
                              onClick={() => window.open(plan.link, "_blank")}
                            >
                              <button
                                type="button"
                                className="removeIcon"
                                onClick={() => removePlan(item, plan)}
                              >
                                X
                              </button>
                              {plan.date}
                              {index !== item.plans.length - 1 ? "," : ""}
                            </li>
                          ) : (
                            <li
                              key={plan.id}
                              className="list-item"
                              onClick={() => window.open(plan.link, "_blank")}
                            >
                              {plan.date}
                              {index !== item.plans.length - 1 ? "," : ""}
                            </li>
                          )
                        )}
                    </ul>
                  </div>
                </React.Fragment>
              )
          )}
        </div>
      </section>
    </div>
  );
};

export default LCPArchives;
